var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "group-panel" }, [
    _vm.group.dsName
      ? _c("div", [
          _c("div", { staticClass: "panel panel-body" }, [
            _c("h3", [
              _c("span", [_vm._v(" " + _vm._s(_vm.group.dsName) + " ")]),
              _vm._v(" "),
              !_vm.isRoot
                ? _c(
                    "a",
                    {
                      staticClass: "pull-right dataset-link",
                      attrs: {
                        href: _vm.objectUrl + _vm.group.dsId,
                        target: "_blank",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fal fa-external-link",
                        attrs: { title: "Open data set in new tab" },
                      }),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.group.dsDefinition) },
            }),
          ]),
          _vm._v(" "),
          _vm.group.name !== "Root"
            ? _c("div", { staticClass: "panel panel-body" }, [
                _c("h4", [_vm._v(" " + _vm._s(_vm.group.name) + " ")]),
                _vm._v(" "),
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.group.description) },
                }),
              ])
            : _vm._e(),
        ])
      : _c("div", [
          _vm.group.name !== "Root"
            ? _c("div", { staticClass: "panel panel-body" }, [
                _c("h3", [_vm._v(" " + _vm._s(_vm.group.name) + " ")]),
                _vm._v(" "),
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.group.description) },
                }),
              ])
            : _vm._e(),
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "panel panel-body group-table" },
      [
        _vm.group.groups.length > 0
          ? _c("div", [
              _c("table", { staticClass: "table table-striped" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "rounded-corners" },
                  _vm._l(_vm.group.groups, function (subgroup) {
                    return _c("tr", { key: subgroup.id }, [
                      _c("td", { staticClass: "name-column-width" }, [
                        _c("span", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.selectGroup(subgroup)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(subgroup.name) + " ")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "definition-width",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getDefaultContent(subgroup.description)
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "count-width",
                          attrs: { title: subgroup.groups.length + " Groups" },
                        },
                        [
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getDefaultContent(subgroup.groups.length)
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "count-width",
                          attrs: {
                            title: subgroup.datasets.length + " Data Sets",
                          },
                        },
                        [
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getDefaultContent(
                                    subgroup.datasets.length
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "count-width",
                          attrs: {
                            title:
                              subgroup.distributions.length + " Distributions",
                          },
                        },
                        [
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getDefaultContent(
                                    subgroup.distributions.length
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.group.datasets.length > 0
          ? _c("h4", [_vm._v("\n            Datasets\n        ")])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.ordered(_vm.group.datasets), function (ds) {
          return _c(
            "div",
            { key: ds.uuid },
            [
              _c(
                "keep-alive",
                [
                  _vm._v(
                    "\n                " + _vm._s(ds) + "\n                "
                  ),
                  _c("nested-dataset-display", { attrs: { dataset: ds } }),
                ],
                1
              ),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.group.distributions.length > 0
          ? _c("h4", [_vm._v("\n            Distributions\n        ")])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.ordered(_vm.group.distributions), function (dist) {
          return _c(
            "div",
            { key: dist.uuid },
            [
              _c(
                "keep-alive",
                [
                  _vm._v(
                    "\n                " + _vm._s(dist) + "\n                "
                  ),
                  _c("nested-distribution-display", {
                    attrs: { distribution: dist },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "name-column-width" }, [
        _vm._v("\n                        Group Name\n                    "),
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "definition-width" }, [
        _vm._v("\n                        Definition\n                    "),
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "count-width", attrs: { title: "Groups" } }, [
        _c("span", { staticClass: "pull-right" }, [
          _c("i", {
            staticClass: "fa fa-folder",
            attrs: { title: "Number of Groups (#)" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "count-width", attrs: { title: "Data Set Count" } },
        [
          _c("span", { staticClass: "pull-right" }, [
            _c("i", {
              staticClass: "fa fa-database",
              attrs: { title: "Number of Data Sets (#)" },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "count-width", attrs: { title: "Distribution Count" } },
        [
          _c("span", { staticClass: "pull-right" }, [
            _c("i", {
              staticClass: "fa fa-file",
              attrs: { title: "Number of Distributions (#)" },
            }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }